import React, {useState, useRef} from 'react';
import {Overlay} from 'react-bootstrap';
import '../../assests/css/managemenu.scss';
import Tooltip from '../common/components/Tooltip';

export type menuItemIdType = 'manageUser' | 'resetPassword' | 'changeRole' | 'deactivateUser' | 'activate' |'None';

interface manageMenuProps {
    targetElement: React.ReactElement,
    targetId: number,
    userStatus: boolean,
    isAdmin: boolean,
    onClick?: (showMenu: boolean, id: number) => void,
    onClickMenuItem: (menuId: menuItemIdType) => void,
}

function ManageMenu(props: manageMenuProps) {
    const {targetElement, targetId, userStatus, isAdmin,
        onClickMenuItem, onClick} = props;
    const [
        showMenu,
        setShowMenu,
    ] = useState<boolean>(false);
    const targetRef = useRef(null);

    const handleShowMenu = (value: boolean) => {
        if (!isAdmin) {
            setShowMenu(value);
            if (onClick && value) {
                onClick(value, targetId)
            }
        }
    };

    const renderContent = () => {
        return (
            <div className='manage-user-menu'>
                <div className='manage-user-menu-item' onClick={() => onClickMenuItem('manageUser')}>Manage</div>
                {/* <div className='manage-user-menu-item' onClick={() => onClickMenuItem('resetPassword')}>Reset Password</div> */}
                <div className='manage-user-menu-item' onClick={() => onClickMenuItem('changeRole')}>Change Role</div>
                {userStatus ?
                <div className='manage-user-menu-item' onClick={() => onClickMenuItem('deactivateUser')}>De-activate user</div> :
                <div className='manage-user-menu-item' onClick={() => onClickMenuItem('activate')}>Activate user</div>}
            </div>
        );
    }
    return (
        <>
            <div
                ref={targetRef}
                onClick={() => handleShowMenu(!showMenu)} className='manage-user-menu-trigger'
            >
                <Tooltip
                    text={isAdmin ? 'You cannot edit admin user' : ''}
                    customClass='d-flex justify-content-center w-100'
                >
                    {targetElement}
                </Tooltip>
            </div>
            <Overlay target={targetRef.current} show={showMenu} rootClose={true} placement='left' rootCloseEvent='click'
            onHide={() => handleShowMenu(false)}>
                {({
                    placement: _placement,
                    arrowProps: _arrowProps,
                    show: _show,
                    popper: _popper,
                    hasDoneInitialMeasure: _hasDoneInitialMeasure,
                    ...props
                }) => (
                    <div {...props}>
                        {renderContent()}
                    </div>
                )}
            </Overlay>
        </>
    );
}

export default ManageMenu;
